import React from "react";
import Grid from "@mui/material/Grid2";
import { SBSection } from "@dndModels";
import { ExtractedObject, fieldLabel } from "./PdfImporter.types";
import DisplayStringWithReplacements from "@dndComponents/display/DisplayStringWithReplacements";
import ModalOrDrawer from "@components/display/ModalOrDrawer";

interface PreviewModalProps {
  obj: ExtractedObject;
  allObjects: ExtractedObject[];
  onClose: () => void;
}

export default function PreviewModal({ obj, allObjects, onClose }: PreviewModalProps) {
  const subsections: SBSection[] = allObjects
    .filter(o => o.fields["parent_id"] === obj.id)
    .map(o => new SBSection({ true_id: o.id, name: o.fields["name"] ?? "", content: o.fields["content"] ?? "" }));

  return (
    <ModalOrDrawer open={true} onClose={onClose}>
      <Grid container spacing={1} direction="column">
        <Grid size={12}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid><strong>Section</strong></Grid>
            <Grid>
              <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", fontSize: "1.2rem", color: "#666" }}>×</button>
            </Grid>
          </Grid>
        </Grid>

        {Object.entries(obj.fields).filter(([k]) => k !== "parent_id").map(([key, val]) => (
          <Grid key={key} size={12}>
            <div style={{ fontSize: "0.75rem", color: "#888", textTransform: "capitalize" }}>{fieldLabel(key)}</div>
            <div style={{ whiteSpace: "pre-wrap", fontSize: "0.9rem" }}>
              <DisplayStringWithReplacements display_string={val} />
            </div>
          </Grid>
        ))}

        {subsections.length > 0 && (
          <Grid size={12}>
            <div style={{ fontSize: "0.75rem", color: "#888", marginBottom: "0.4rem" }}>Subsections</div>
            {/* <SBSectionsEditor sections={subsections} disabled /> */}
          </Grid>
        )}

        {Object.entries(obj.fields).length === 0 && (
          <Grid size={12} style={{ color: "#888", fontStyle: "italic" }}>No fields set yet.</Grid>
        )}
      </Grid>
    </ModalOrDrawer>
  );
}